/* src/app/shared/components/mce-editor/table-grid-picker.component.scss */
.tgp-container {
  padding: 8px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  -webkit-user-select: none;
  user-select: none;
}
.tgp-grid {
  display: grid;
  grid-template-columns: repeat(8, 20px);
  grid-template-rows: repeat(8, 20px);
  gap: 2px;
}
.tgp-cell {
  width: 20px;
  height: 20px;
  border: 1px solid #bdbdbd;
  border-radius: 2px;
  background: #fff;
  cursor: pointer;
  transition: background 0.08s, border-color 0.08s;
}
.tgp-cell:hover,
.tgp-cell.tgp-cell--active {
  background: #bbdefb;
  border-color: #1565c0;
}
.tgp-label {
  margin-top: 6px;
  text-align: center;
  font-size: 12px;
  color: #616161;
  min-height: 16px;
}
/*# sourceMappingURL=table-grid-picker.component-HNXP6MII.css.map */
